/**
 * Allows the httpClient interceptor (and other code) to notify AuthContext
 * when tokens are cleared (e.g. after 401 refresh failure), so UI state
 * stays in sync with localStorage.
 */
let onSessionCleared: (() => void) | null = null;

export function setSessionClearHandler(handler: () => void) {
  onSessionCleared = handler;
}

export function notifySessionCleared() {
  onSessionCleared?.();
}
